import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Star, ShoppingBag } from 'lucide-react';
import { products, testimonials } from '../data/mock';
import ProductCarousel from '../components/ProductCarousel';
import BuyModal from '../components/BuyModal';

const Home = () => {
  const featuredProducts = products.slice(0, 4);
  const [selectedProduct, setSelectedProduct] = useState(null);

  return (
    <div>
      {/* Hero Carousel Section */}
      <ProductCarousel />

      {/* Features Section */}
      <section className="section-padding-small" style={{
        backgroundColor: '#f6f5e8'
      }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '48px'
          }}>
            <div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Premium Quality
              </h3>
              <p className="body-regular" style={{ color: '#666666' }}>
                All products are made with high-grade materials ensuring durability and long-lasting performance.
              </p>
            </div>
            <div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Easy Installation
              </h3>
              <p className="body-regular" style={{ color: '#666666' }}>
                Designed for simple self-installation with all necessary hardware included in the package.
              </p>
            </div>
            <div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Fast Delivery
              </h3>
              <p className="body-regular" style={{ color: '#666666' }}>
                Quick and reliable shipping across India with secure packaging.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="section-padding" style={{
        backgroundColor: '#fffef2'
      }}>
        <div className="container">
          <div style={{ 
            textAlign: 'center', 
            marginBottom: '64px',
            maxWidth: '600px',
            margin: '0 auto 64px'
          }}>
            <h2 className="hero-medium" style={{ marginBottom: '16px' }}>
              Our Products
            </h2>
            <p className="body-large" style={{ color: '#666666' }}>
              Explore our carefully curated collection of bathroom essentials
            </p>
          </div>

          <div className="grid-product-showcase">
            {featuredProducts.map(product => (
              <Link 
                key={product.id}
                to={`/product/${product.id}`}
                className="product-card hover-lift"
              >
                <img 
                  src={product.image}
                  alt={product.name}
                  className="product-card-image"
                  style={{ backgroundColor: '#fff' }}
                />
                <div style={{ padding: '16px' }}>
                  <h3 className="product-card-title">
                    {product.name}
                  </h3>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px',
                    marginBottom: '8px'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <Star size={14} fill="#333333" color="#333333" />
                      <span className="body-small">{product.rating}</span>
                    </div>
                    <span className="body-small" style={{ color: '#bcbbb4' }}>
                      ({product.reviews} reviews)
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '12px' }}>
                    <span className="heading-3">₹{product.price.toLocaleString()}</span>
                    <span className="body-small" style={{ 
                      color: '#bcbbb4', 
                      textDecoration: 'line-through' 
                    }}>
                      ₹{product.originalPrice.toLocaleString()}
                    </span>
                    <span className="body-small" style={{ color: '#ba3e2b' }}>
                      {product.discount}% off
                    </span>
                  </div>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedProduct(product);
                    }}
                    className="btn-primary"
                    style={{
                      width: '100%',
                      minWidth: 'auto',
                      height: '48px',
                      padding: '12px 16px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px'
                    }}
                  >
                    <ShoppingBag size={16} />
                    Buy Now
                  </button>
                </div>
              </Link>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: '48px' }}>
            <Link to="/products" className="btn-primary">
              View All Products
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="section-padding-small" style={{
        backgroundColor: '#f6f5e8'
      }}>
        <div className="container">
          <h2 className="hero-medium" style={{ 
            textAlign: 'center', 
            marginBottom: '64px' 
          }}>
            What Our Customers Say
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '32px'
          }}>
            {testimonials.map(testimonial => (
              <div key={testimonial.id} style={{
                backgroundColor: '#fffef2',
                padding: '32px',
                borderRadius: '0px'
              }}>
                <div style={{ 
                  display: 'flex', 
                  gap: '4px', 
                  marginBottom: '16px' 
                }}>
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={16} fill="#333333" color="#333333" />
                  ))}
                </div>
                <p className="body-regular" style={{ 
                  marginBottom: '16px',
                  color: '#666666'
                }}>
                  "{testimonial.comment}"
                </p>
                <div>
                  <p className="body-small" style={{ fontWeight: '500' }}>
                    {testimonial.name}
                  </p>
                  <p className="body-small" style={{ color: '#bcbbb4' }}>
                    {testimonial.product}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding" style={{
        backgroundColor: '#333333',
        color: '#fffef2'
      }}>
        <div className="container">
          <div style={{
            textAlign: 'center',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            <h2 className="hero-medium" style={{ 
              marginBottom: '24px',
              color: '#fffef2'
            }}>
              Ready to Upgrade Your Bathroom?
            </h2>
            <p className="body-large" style={{ 
              marginBottom: '32px',
              color: '#bcbbb4'
            }}>
              Browse our complete collection and find the perfect products for your home
            </p>
            <Link 
              to="/products" 
              className="btn-primary" 
              style={{
                backgroundColor: '#fffef2',
                color: '#333333',
                border: '1px solid #fffef2'
              }}
            >
              Shop Now
            </Link>
          </div>
        </div>
      </section>

      {/* Buy Modal */}
      {selectedProduct && (
        <BuyModal 
          product={selectedProduct} 
          onClose={() => setSelectedProduct(null)} 
        />
      )}
    </div>
  );
};

export default Home;
